import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setZoomAction } from '../../../../Redux/Actions/Atlas/zoom.action';

import './Zoom.style.scss';
import { Observer, GLOBAL_EVENT } from '../../Observer';
import { RootState } from '../../../../Redux/Store/store';
import { AddButton } from '../../../AnimationTool/components/buttons/Buttons';

const Zoom = () => {
    const zoomPercent: number = useSelector((state: RootState) => state.zoomAtlas.value);
    const dispatch = useDispatch();

    const minZoom = 20;
    const maxZoom = 500;
    const zoomStep = 10;

    const handleInputZoom = (percentInput: number) => {
        const numberPercent: number = Math.round(percentInput);
        const finalZoom: number =
            numberPercent <= minZoom ? minZoom : numberPercent >= maxZoom ? maxZoom : numberPercent;
        dispatch(setZoomAction({ value: finalZoom }));
    };

    Observer.emit(GLOBAL_EVENT.ZOOM_CHANGED, zoomPercent);

    return (
        <div className="zoom-tools">
            <input
                type="number"
                onChange={(event) => handleInputZoom(Number(event.target.value))}
                value={zoomPercent}
            />
            <span className="noselect">%</span>
            <div className="btns-container">
                <AddButton className="ml-2" onClick={() => handleInputZoom(100)}>
                    <span className="px-2" style={{ fontSize: '1rem' }}>
                        Reset
                    </span>
                </AddButton>
                <AddButton className="ml-1" onClick={() => handleInputZoom(zoomPercent - zoomStep)}>
                    -
                </AddButton>
                <AddButton className="ml-1" onClick={() => handleInputZoom(zoomPercent + zoomStep)}>
                    +
                </AddButton>
            </div>
        </div>
    );
};

export default Zoom;
